import DataContext from "./data-context";
import SelectContext from "./select-context";
import SortContext from "./sort-context";
import PaginationContext from "./pagination-context";

export default {
  DataContext: DataContext(),
  SelectContext,
  SortContext,
  PaginationContext
};
